/**
 * Suppresses stream error banners during WebSocket reconnect and surfaces a single
 * message when client reconnect retries are exhausted.
 */
import { useContext, useEffect, useRef } from 'react';
import { BannerContext } from '../contexts/BannerContext';
import { useWebSocket } from '../contexts/WebSocketContext';
import { clearAllStreamErrorBanners } from '../utils/streamErrorBanner';

export default function StreamConnectionMonitor() {
  const { tradingReady, chartsReady, connectionLost } = useWebSocket();
  const { showMessage } = useContext(BannerContext);
  const wasConnectionLostRef = useRef(false);

  useEffect(() => {
    if (!tradingReady || !chartsReady) {
      clearAllStreamErrorBanners();
    }
  }, [tradingReady, chartsReady]);

  useEffect(() => {
    if (connectionLost && !wasConnectionLostRef.current) {
      showMessage?.(
        'Lost connection to live market data. Refresh the page if streams do not recover.',
        'danger'
      );
    }
    wasConnectionLostRef.current = connectionLost;
  }, [connectionLost, showMessage]);

  return null;
}
